var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationEtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 110,
    viewBox: "0 0 181 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9067,
    y: 33.2539,
    width: 112.044,
    height: 71.1144,
    fill: "#6299FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2305 68.8111L129.95 33.1439L129.95 104.478L76.2305 68.8111Z",
    fill: "#8DB5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6259 68.8111L17.9064 33.1439L17.9064 104.478L71.6259 68.8111Z",
    fill: "#8DB5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1343 72.5458C78.7209 78.1685 69.1338 78.1685 62.7204 72.5458L17.9056 33.2561H129.949L85.1343 72.5458Z",
    fill: "#C4D8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.5749,
    y: 0.5,
    width: 84.9512,
    height: 108.997,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.128,
    y: 65.9922,
    width: 65.9966,
    height: 4.39977,
    rx: 2.19989,
    fill: "#CACACA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.128,
    y: 54.2656,
    width: 65.9966,
    height: 4.39977,
    rx: 2.19989,
    fill: "#CACACA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.128,
    y: 77.7266,
    width: 65.9966,
    height: 4.39977,
    rx: 2.19989,
    fill: "#CACACA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 104.128,
    y: 89.4688,
    width: 46.9309,
    height: 4.39977,
    rx: 2.19989,
    fill: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.755 21.9193L137.067 16.4336L124.181 21.9193V28.2805C124.181 31.9571 123.864 35.8088 128.279 41.6447C130.609 44.7258 135.108 46.5858 137.067 47.1304C138.548 46.9359 142.339 45.5664 145.657 41.6447C149.755 36.8009 149.771 31.1012 149.755 28.2805V21.9193Z",
    fill: "#00C968"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.85 32.6435L135.261 36.6227L142.651 27.5273",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationEtc);
export default __webpack_public_path__ + "static/media/IcCertificationEtc.7e720c7d29215a4b7780fbe428def644.svg";
export { ForwardRef as ReactComponent };